import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'

import { useFormik } from 'formik'
import { CurrencyCodeEnum } from '@/enums'
import { ApplicationState } from '@/state/root.models'

import { useBrandsActions } from './use-brands-actions.hook'

export const useBrandsForm = () => {
  const { t } = useTranslation()

  const { brands, isLoading, currentBrand } = useSelector(
    ({ brands }: ApplicationState) => brands,
  )

  const { saveBrand, updateBrand, setCurrentBrand } = useBrandsActions()

  const initialValues = {
    name: currentBrand?.name || '',
    enable: currentBrand?.enable || false,
    siteId: currentBrand?.siteId || 0,
    currencies: currentBrand?.currencies || [CurrencyCodeEnum.USD],
    operatorId: currentBrand?.operatorId || 0,
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t('error.requiredField')),
    siteId: Yup.number().required(t('error.requiredField')),
    currencies: Yup.array().min(1),
  })

  const formikBrand = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: () => {},
    enableReinitialize: true,
  })

  const handleSaveBrand = () => {
    if (currentBrand?.id) {
      updateBrand({
        id: currentBrand.id,
        name: formikBrand.values.name,
        siteId: currentBrand.siteId,
        enable: formikBrand.values.enable,
        currencies: formikBrand.values.currencies,
        operatorId:
          process.env.REACT_APP_STAGE === 'prod'
            ? undefined
            : formikBrand.values.operatorId,
      })
    } else {
      saveBrand({
        name: formikBrand.values.name,
        siteId: Number(formikBrand.values.siteId),
        enable: formikBrand.values.enable,
        currencies: formikBrand.values.currencies,
        operatorId:
          process.env.REACT_APP_STAGE === 'prod'
            ? undefined
            : formikBrand.values.operatorId,
      })
    }
  }

  return {
    handleSaveBrand,
    setCurrentBrand,
    isLoading,
    brands,
    formikBrand,
    currentBrand,
  }
}
